import {
  Step as MuiStep,
  StepButton as MuiStepButton,
  type StepButtonProps as MuiStepButtonProps,
  StepConnector as MuiStepConnector,
  type StepConnectorProps as MuiStepConnectorProps,
  StepContent as MuiStepContent,
  type StepContentProps as MuiStepContentProps,
  StepLabel as MuiStepLabel,
  type StepLabelProps as MuiStepLabelProps,
  Stepper as MuiStepper,
  type StepperProps as MuiStepperProps,
  type StepProps as MuiStepProps
} from "@mui/material";

export type StepperProps = MuiStepperProps;
export type StepProps = MuiStepProps;
export type StepLabelProps = MuiStepLabelProps;
export type StepContentProps = MuiStepContentProps;
export type StepButtonProps = MuiStepButtonProps;
export type StepConnectorProps = MuiStepConnectorProps;

export const Stepper = MuiStepper;
export const Step = MuiStep;
export const StepLabel = MuiStepLabel;
export const StepContent = MuiStepContent;
export const StepButton = MuiStepButton;
export const StepConnector = MuiStepConnector;
